import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, PlusSquare, Boxes, ShoppingBag, LineChart, BarChart3, Settings, LogOut, Star, Wrench, LifeBuoy } from "lucide-react";
import { useAdminAuth } from "./auth";

const NAV = [
  { to: "/admin/dashboard", label: "Dashboard", Icon: LayoutDashboard },
  { to: "/admin/parts", label: "Auto Parts", Icon: Wrench },
  { to: "/admin/parts/new", label: "Add Part", Icon: PlusSquare },
  { to: "/admin/products", label: "Tyres", Icon: Package },
  { to: "/admin/stock", label: "Stock", Icon: Boxes },
  { to: "/admin/orders", label: "Orders", Icon: ShoppingBag },
  { to: "/admin/recovery", label: "Recovery", Icon: LifeBuoy },
  { to: "/admin/revenue", label: "Revenue", Icon: LineChart },
  { to: "/admin/analytics", label: "Analytics", Icon: BarChart3 },
  { to: "/admin/reviews", label: "Reviews", Icon: Star },
  { to: "/admin/settings", label: "Settings", Icon: Settings },
];

const AdminLayout = () => {
  const { user, logout } = useAdminAuth();
  const navigate = useNavigate();
  const onLogout = async () => { await logout(); navigate("/admin/login"); };

  return (
    <div className="vd-page" data-testid="admin-layout" style={{ minHeight: "100vh", background: "var(--bg-secondary)" }}>
      <div className="grid grid-cols-[240px_1fr]" style={{ minHeight: "100vh" }}>
        <aside
          className="vd-card"
          data-testid="admin-sidebar"
          style={{ borderRadius: 0, borderRight: "1px solid var(--border-color)", padding: 0, position: "sticky", top: 0, height: "100vh", overflowY: "auto" }}
        >
          <div className="px-5 py-5 border-b" style={{ borderColor: "var(--border-color)" }}>
            <p className="vd-heading font-extrabold" style={{ fontSize: 18 }}>ValueDrive Admin</p>
            <p className="vd-muted text-xs mt-1">{user?.email}</p>
          </div>
          <nav className="px-2 py-3 flex flex-col gap-1">
            {NAV.map(({ to, label, Icon }) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/admin/products"}
                className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ${isActive ? "" : "hover:bg-[var(--bg-secondary)]"}`}
                style={({ isActive }) => ({
                  background: isActive ? "rgba(230,0,0,0.10)" : "transparent",
                  color: isActive ? "var(--primary-red)" : "var(--text-heading)",
                  border: isActive ? "1px solid rgba(230,0,0,0.35)" : "1px solid transparent",
                })}
                data-testid={`admin-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <Icon size={16} /> {label}
              </NavLink>
            ))}
          </nav>
          <div className="px-3 mt-3">
            <button
              onClick={onLogout}
              className="vd-btn-secondary w-full justify-center text-sm"
              data-testid="admin-logout-btn"
            ><LogOut size={14} /> Sign out</button>
          </div>
        </aside>

        <main className="p-8 overflow-x-auto" data-testid="admin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
